/**
 * Zod schema for linkable text fields.
 * No validations listed; accept any value.
 */

import { z } from 'zod';
import type { FieldSchemaConfig } from '../types';

export function getLinkableSchema(_col: FieldSchemaConfig): z.ZodTypeAny {
  return z.any();
}
